import React from 'react';
import { Spinner } from '../general/Spinner';
import { Text } from '../general/Text';

export interface SecondaryButtonProps {
  text: string;
  callback: () => void;
  isLoading?: boolean;
  isEnabled?: boolean;
  foregroundColor?: string;
  backgroundColor?: string;
}

export const SecondaryButton: React.FC<SecondaryButtonProps> = ({
  text,
  callback,
  isLoading = false,
  isEnabled = true,
  foregroundColor = 'var(--text-primary)',
  backgroundColor = 'white'
}) => {
  const buttonStyle: React.CSSProperties = {
    backgroundColor: backgroundColor,
    color: isEnabled ? foregroundColor : 'var(--color-disabled)',
    padding: '8px',
    border: `1px solid ${isEnabled ? foregroundColor : 'var(--color-disabled)'}`,
    borderRadius: '8px',
    cursor: isEnabled ? 'pointer' : 'not-allowed',
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '48px',
    width: '100%',
    transition: 'background-color 0.2s, color 0.2s, border-color 0.2s, filter 0.2s'
  };

  return (
    <>
      <style>{`
        .secondary-button-hover:enabled:hover {
          filter: brightness(0.9) !important;
        }
      `}</style>
      <button
        onClick={!isLoading && isEnabled ? callback : undefined}
        disabled={!isEnabled}
        style={buttonStyle}
        className='secondary-button-hover'
      >
        {isLoading ? (
          <Spinner size={16} color={foregroundColor} />
        ) : (
          <Text
            variant='body1'
            style={{
              color: isEnabled ? foregroundColor : 'var(--color-disabled)'
            }}
          >
            {text}
          </Text>
        )}
      </button>
    </>
  );
};
